import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { combineLatest, Observable, of } from "rxjs";
import { catchError, map, mergeMap, take } from "rxjs/operators";
import { AuthenticationService } from "./authentication.service";
import { environment } from "@env/environment";
import { firebase } from "../../firebase/firebase";
import { FirebaseAuthenticationService } from "./../auth/firebase-authentication.service";
import { NotificationService } from "@app/shared/services/notification.service";

@Injectable()
export class AuthenticationResolver implements Resolve<any> {
  constructor(
    public auth: AuthenticationService,
    public fauth: FirebaseAuthenticationService,
    public notify: NotificationService
  ) { }
  public authenticate(): Observable<any> {
    const promise = [];
    promise.push(this.auth.authenticate());

    return combineLatest(promise);
  }

  resolve() {
    return this.authenticate().pipe(
      take(1),
      catchError((error) => {
        let msg = "";
        if (typeof error === "string") {
          msg = JSON.parse(error) || error;
        } else if (typeof error === "object") {
          msg = error.message || error.code;
        }
        this.notify.error(msg);
        return of(false);
      })
    );
  }
}